module.exports = __webpack_public_path__ + "img/profile3.827edb2f.jpg";